import { ComponentProps } from "react"
import { Link as ReactLink } from "react-router"

import cn from "@/util/cn"

type LinkProps = {
  type?: "link" | "button"
  className?: string
} & ComponentProps<typeof ReactLink>

const Link = ({ type = "link", className, children, ...otherProps }: LinkProps) => (
  <ReactLink
    className={cn(
      "text-primary-contrast",
      type === "link"
        ? "hover:underline"
        : "flex select-none justify-center rounded-md border-4 border-primary bg-white px-3 py-1.5 text-sm font-semibold leading-6 shadow-card hover:bg-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-50",
      className,
    )}
    {...otherProps}
  >
    {children}
  </ReactLink>
)

export default Link
